import { createContext, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// ----------------------------------------------------------------------

const DateContext = createContext();

function DateProvider({ children }) {
  const [date, setDate] = useState(() => {
    const storedDate = sessionStorage.getItem('selected_date');
    if (storedDate) {
      try {
        const parsedDate = new Date(storedDate);
        // Check if the date is valid
        if (!Number.isNaN(parsedDate.getTime())) {
          return parsedDate;
        }
      } catch (error) {
        console.error('Error parsing stored date:', error);
      }
    }
    return new Date();
  });

  const onChangeDate = useCallback((newDate) => {
    if (newDate) {
      // DatePicker passes Date object directly, not an event
      setDate(newDate);
    }
  }, []);

  useEffect(() => {
    if (date && date instanceof Date && !Number.isNaN(date.getTime())) {
      // Store as ISO string for reliable parsing
      sessionStorage.setItem('selected_date', date.toISOString());
    }
  }, [date]);

  return (
    <DateContext.Provider
      value={{
        date,
        onChangeDate,
      }}
    >
      {children}
    </DateContext.Provider>
  );
}

export { DateProvider, DateContext };

DateProvider.propTypes = {
  children: PropTypes.node,
};
